import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicMarieStopesLekki from "../Components/ProjPicMarieStopes";

const ProjectPageMarieStopesLekki = () => {
    return (
        <>
            <Navbar />
            <ProjPicMarieStopesLekki />
            <Footer />
        </>
    );
};

export default ProjectPageMarieStopesLekki;
